export const APIBASE_HOST = "https://mainapi.myperformancelearning.com";
export const MEDIABASE_HOST = "https://d29x94w0cyhvbe.cloudfront.net";
export const PROXIED_MEDIABASE_HOST = "https://d29x94w0cyhvbe.cloudfront.net";
export const SOCKET_HOST = "https://socket.myperformancelearning.com";
// export const STRIPE_KEY = "pk_live_w3AtS2ozgqgePGkWTgz7juPd";
export const STRIPE_KEY =
  "pk_test_51RdRV3FvsucrTYjfRjipQdS2yfuletoeeJMEmXcnQLXqXPFIdGRUL1unZM4iJ7bz2r78KMTMSinZNtOfNuPNN6ZO00o5nYqs7v";
export const VIDEO_BASE = "https://vod.myperformancelearning.com/id/";



// WEBPACK FOOTER //
// ./src/common/env.js